import { createMultiStyleConfigHelpers } from '~/utils/chakraUtils'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const CallCenterSettingsParts = [
  'customStatusContainer',
  'customStatusContent',
  'statusIndicator',
  'statusTitle',
  'statusDescription',
  'actionButtons',
] as const

const helpers = createMultiStyleConfigHelpers(CallCenterSettingsParts)

export const CallCenterSettingsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    customStatusWrapper: {
      width: '100%',
      gap: '0.5rem',
      flexDir: 'column',
      alignItems: 'flex-start',
    },
    customStatusHeaderContainer: {
      gap: '1.75rem',
      flexDir: 'column',
    },
    customStatusHeaderContent: {
      flexDir: 'column',
      alignItems: 'flex-start',
      gap: '0.625rem',
    },
    customStatusContainer: {
      width: '100%',
      gap: '0.5rem',
      padding: '0.25rem 0.75rem',
      alignItems: 'center',
      borderRadius: '0.5rem',
      border: '1px solid',
      borderColor: 'border.default',
      background: 'bg.subtle',
    },
    customStatusContent: {
      flexDir: 'column',
      padding: '0.25rem 0rem',
      alignItems: 'flex-start',
      flex: '1 0 0',
    },
    statusIndicator: {
      width: '1rem',
      height: '1rem',
      borderRadius: '6.25rem',
    },
    statusTitle: {
      overflow: 'hidden',
      color: 'fg.default',
      textOverflow: 'ellipsis',
      ...textStyles[textStyleKeys.Body2],
    },
    statusDescription: {
      overflow: 'hidden',
      color: 'fg.muted',
      textOverflow: 'ellipsis',
      ...textStyles[textStyleKeys.Body3],
    },
    actionButtons: {
      gap: '0.25rem',
    },
  },
})
